import { lazy } from "react";
import { Navigate, Outlet, type RouteObject } from "react-router";
import MainLayout from "@/layouts/MainLayout";
import { useAuth } from "@/context/AuthContext";

const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

const PublicOnlyRoute = () => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? <Navigate to="/" replace /> : <Outlet />;
};

export const routes: RouteObject[] = [
  // { path: "", element: <Navigate to="/login" /> },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <MainLayout />,
        children: [
          {
            path: "/",
            Component: lazy(() => import("@/views/pages/home")),
          },
          {
            path: "/profile",
            Component: lazy(() => import("@/views/pages/profile")),
          },
          {
            path: "/programmesbroadcasts",
            Component: lazy(() => import("@/views/pages/programmesbroadcasts")),
          },
          {
            path: "/accreditationrequests",
            Component: lazy(() => import("@/views/pages/accreditation")),
          },
          {
            path: "/attendancecredits",
            Component: lazy(() => import("@/views/pages/attendance")),
          },

          {
            path: "/schedule",
            Component: lazy(() => import("@/views/pages/schedule")),
          },

          // {
          //   path: "/certificates",
          //   Component: lazy(() => import("@/views/pages/certificates")),
          // },
          {
            path: "/members",
            Component: lazy(() => import("@/views/pages/members")),
          },
          {
            path: "/layouts/scrollable",
            Component: lazy(() => import("@/views/layouts/scrollable")),
          },
          {
            path: "/layouts/sidebar-compact",
            Component: lazy(() => import("@/views/layouts/sidebar-compact")),
          },
          {
            path: "/layouts/sidebar-gradient",
            Component: lazy(() => import("@/views/layouts/sidebar-gradient")),
          },
          {
            path: "/layouts/sidebar-gray",
            Component: lazy(() => import("@/views/layouts/sidebar-gray")),
          },
          {
            path: "/layouts/sidebar-image",
            Component: lazy(() => import("@/views/layouts/sidebar-image")),
          },
          {
            path: "/layouts/sidebar-light",
            Component: lazy(() => import("@/views/layouts/sidebar-light")),
          },
          {
            path: "/layouts/sidebar-no-icons",
            Component: lazy(() => import("@/views/layouts/sidebar-no-icons")),
          },
          {
            path: "/layouts/sidebar-offcanvas",
            Component: lazy(() => import("@/views/layouts/sidebar-offcanvas")),
          },
          {
            path: "/layouts/sidebar-on-hover",
            Component: lazy(() => import("@/views/layouts/sidebar-on-hover")),
          },
          {
            path: "/layouts/sidebar-with-lines",
            Component: lazy(() => import("@/views/layouts/sidebar-with-lines")),
          },
          {
            path: "/layouts/topbar-dark",
            Component: lazy(() => import("@/views/layouts/topbar-dark")),
          },
          {
            path: "/layouts/topbar-gradient",
            Component: lazy(() => import("@/views/layouts/topbar-gradient")),
          },
          {
            path: "/layouts/topbar-gray",
            Component: lazy(() => import("@/views/layouts/topbar-gray")),
          },
          {
            path: "/pages/empty",
            Component: lazy(() => import("@/views/pages/empty")),
          },
        ],
      },
    ],
  },

  {
    path: "/auth/delete-account",
    Component: lazy(() => import("@/views/auth/delete-account")),
  },
  // {
  //   path: "/auth/lock-screen",
  //   Component: lazy(() => import("@/views/auth/lock-screen")),
  // },
  {
    path: "/auth/login-pin",
    Component: lazy(() => import("@/views/auth/login-pin")),
  },
  {
    path: "/auth/verify-pass",
    Component: lazy(() => import("@/views/auth/verify-pass-otp")),
  },
  {
    path: "/auth/req-pass",
    Component: lazy(() => import("@/views/auth/req-pass-otp")),
  },
  {
    path: "/attendance/:attendance_token",
    Component: lazy(() => import("@/views/pages/attendanceForm")),
  },
  {
    element: <PublicOnlyRoute />,
    children: [
      {
        path: "/login",
        Component: lazy(() => import("@/views/auth/sign-in")),
      },
      {
        path: "/sign-up",
        Component: lazy(() => import("@/views/auth/sign-up")),
      },
    ],
  },
  // {
  //   path: "/event/:id",
  //   Component: lazy(
  //     () => import("@/views/pages/programmesbroadcasts/programme"),
  //   ),
  // },

  // {
  //   path: "/auth/success-mail",
  //   Component: lazy(() => import("@/views/auth/success-mail")),
  // },
  // {
  //   path: "/auth/two-factor",
  //   Component: lazy(() => import("@/views/auth/two-factor")),
  // },
  { path: "/error/400", Component: lazy(() => import("@/views/error/400")) },
  { path: "/error/401", Component: lazy(() => import("@/views/error/401")) },
  { path: "/error/403", Component: lazy(() => import("@/views/error/403")) },
  { path: "/error/404", Component: lazy(() => import("@/views/error/404")) },
  { path: "/error/408", Component: lazy(() => import("@/views/error/408")) },
  { path: "/error/500", Component: lazy(() => import("@/views/error/500")) },
  {
    path: "/error/maintenance",
    Component: lazy(() => import("@/views/error/maintenance")),
  },
];
